var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagazine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55,21V11h-4V1H5v57c0,2.757,2.243,5,5,5h44c2.757,0,5-2.243,5-5V21H55z M10,61c-1.654,0-3-1.346-3-3V3h42v55   c0,1.125,0.373,2.164,1.002,3H10z M57,58c0,1.654-1.346,3-3,3s-3-1.346-3-3V13h2v42h2V23h2V58z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 53,
    y: 57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.373,47.209L36,46.246v-0.267c1.246-0.939,2-2.416,2-3.979v-1.828c0-2.646-1.982-4.907-4.513-5.148   c-1.401-0.138-2.81,0.33-3.85,1.275C28.597,37.245,28,38.594,28,40v2c0,1.563,0.754,3.04,2,3.979v0.267l-3.374,0.963   C24.491,47.82,23,49.797,23,52.018V55h20v-2.982C43,49.797,41.509,47.82,39.373,47.209z M41,53H25v-0.982   c0-1.332,0.895-2.519,2.176-2.885L32,47.754V44.87l-0.497-0.289C30.562,44.033,30,43.068,30,42v-2c0-0.844,0.358-1.653,0.982-2.221   c0.633-0.576,1.448-0.843,2.315-0.766C34.813,37.158,36,38.546,36,40.172V42c0,1.068-0.562,2.033-1.503,2.581L34,44.87v2.884   l4.823,1.379C40.105,49.499,41,50.686,41,52.018V53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,59h28V31H19V59z M21,33h24v24H21V33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,29c6.617,0,12-5.383,12-12S27.617,5,21,5S9,10.383,9,17S14.383,29,21,29z M21,27c-4.078,0-7.588-2.458-9.143-5.967   c1.205,0.082,2.332,0.569,3.194,1.431l0.207,0.207C16.114,23.528,17.253,24,18.465,24C20.966,24,23,21.966,23,19.465V18.5   c0-1.93-1.57-3.5-3.5-3.5c-0.827,0-1.5-0.673-1.5-1.5V12c0-1.435-0.463-2.849-1.288-4.02c1.034-0.494,2.161-0.821,3.353-0.932   C20.037,7.274,20,7.501,20,7.728c0,1.75,0.783,3.381,2.15,4.474l1.704,1.362C24.582,14.146,25,15.016,25,15.947   C25,18.733,27.267,21,30.053,21c0.036,0,0.074-0.007,0.11-0.008C28.618,24.524,25.094,27,21,27z M31,17   c0,0.661-0.068,1.307-0.191,1.933C30.555,18.973,30.302,19,30.053,19C28.369,19,27,17.631,27,15.947c0-1.542-0.69-2.98-1.896-3.945   l-1.704-1.363C22.51,9.928,22,8.866,22,7.728c0-0.222,0.022-0.445,0.066-0.669C27.08,7.593,31,11.846,31,17z M15.008,9.013   C15.647,9.87,16,10.93,16,12v1.5c0,1.93,1.57,3.5,3.5,3.5c0.827,0,1.5,0.673,1.5,1.5v0.965C21,20.862,19.862,22,18.465,22   c-0.678,0-1.314-0.264-1.793-0.742l-0.207-0.207C15.143,19.729,13.385,19,11.515,19c-0.103,0-0.21-0.014-0.318-0.03   C11.069,18.332,11,17.674,11,17C11,13.735,12.58,10.84,15.008,9.013z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 12,
    x: 35,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 35,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 39,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 12,
    x: 35,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 12,
    x: 35,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 35,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 45,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 9,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 9,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 9,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 9,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 8,
    x: 9,
    y: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazine);
export default __webpack_public_path__ + "static/media/magazine.e6101386163cbb7defa71d0c24ce2a42.svg";
export { ForwardRef as ReactComponent };